import type React from 'react';

/**
 * The button styles the asset forms share: the equipment and line forms
 * (PnidMarkDialog) and the instrument form (InstrumentEditor). A form's Save and
 * Cancel take the `.pnid-btn` recipe; these cover the rest.
 */

/** The footer's text buttons that remove or replace the saved element. */
export const footerDangerButtonStyle: React.CSSProperties = {
  padding: '8px 14px',
  border: 'none',
  background: 'transparent',
  color: 'var(--raven-error-text)',
  borderRadius: 6,
  cursor: 'pointer',
  fontSize: '13px',
  fontWeight: 500,
};

/** Opens a linked document in a new tab. */
export const openLinkedDocumentButtonStyle: React.CSSProperties = {
  padding: '4px 8px',
  fontSize: 10,
  color: 'var(--raven-primary-main)',
  backgroundColor: 'var(--raven-state-selected)',
  border: '1px solid var(--raven-primary-light)',
  borderRadius: 3,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

/** A section header's "+ Add …" button, which appends a row to the section. */
export function addRowButtonStyle(disabled: boolean): React.CSSProperties {
  return {
    padding: '2px 8px',
    fontSize: 9,
    fontWeight: 500,
    color: 'var(--raven-text-secondary)',
    backgroundColor: 'var(--raven-state-selected)',
    border: '1px solid var(--raven-primary-light)',
    borderRadius: 4,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.55 : 1,
  };
}

/** Removes one row of a section. */
export function removeRowButtonStyle(disabled: boolean): React.CSSProperties {
  return {
    padding: '4px 8px',
    fontSize: 11,
    color: 'var(--raven-text-secondary)',
    background: 'white',
    border: '1px solid var(--raven-divider)',
    borderRadius: 4,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.55 : 1,
  };
}

/** Opens a row's own editor, or another editor for this element. */
export function rowEditButtonStyle(disabled: boolean): React.CSSProperties {
  return {
    padding: '3px 8px',
    fontSize: 10,
    fontWeight: 500,
    color: 'var(--raven-primary-main)',
    backgroundColor: 'var(--raven-state-selected)',
    border: '1px solid var(--raven-primary-light)',
    borderRadius: 3,
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.55 : 1,
  };
}
